import React, {Component} from 'react';
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Paper from "@material-ui/core/Paper";
import ResourceAPIs from "../utils/ResourceAPI";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {handleErr} from '../utils/MiscellaniousUtils';
import {TaskTableRow} from './TaskTableRow';

const MySwal = withReactContent(Swal);

class Tasks extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isProcessing: false,
            results: [],
            isLoaded: false,
            msg: "Loading"
        };
    }

    fetchTasks() {
        new ResourceAPIs().getTasks().then(response => {
            this.setState({
                results: this.updateTaskData(response.data),
                isLoaded: true,
                msg: "",
            });
        }).catch(error => {
            this.stopIntervalTask();
            this.setState({
                results: error,
                isLoaded: false,
                msg: "[Error] Fetching tasks failed, Please contact admin",
            });
        });
    }

    tick() {
        this.fetchTasks();
    }

    componentDidMount() {
        this.fetchTasks();
        this.interval = setInterval(() => this.tick(), 30000);
    }

    stopIntervalTask = () => {
        clearInterval(this.interval);
    };

    updateTaskData(data) {
        let responses = [];
        data.forEach(task => {
            responses.push(task);
        });
        return responses
    }

    stopTask = (id) => {
        MySwal.fire({
            title: 'You want to Stop Task with ID ' + id + '?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Stop it!'
        }).then((result) => {
            if (result.value) {
                new ResourceAPIs().stopTask(id).then(res => {
                    MySwal.fire(
                        'Stopped!',
                        'Task ' + id + ' has been Stopped.',
                        'success'
                    );
                    this.changeTaskStatus(id, "Failed")
                }).catch(error => {
                    handleErr(error);
                });
            }
        });
    };

    changeTaskStatus = (id, status) => {
        this.state.results.forEach((task, index) => {
            if (task.id === id) {
                let newState = Object.assign({}, this.state);
                newState.results[index].status = status;
                this.setState(newState);
            }
        });
    };

    startTask = (id) => {
        new ResourceAPIs().startTask(id).then(res => {
            MySwal.fire(
                'Started!',
                'Task ' + id + ' has been Started.',
                'success'
            );
            this.fetchTasks();
        }).catch(error => {
            handleErr(error);
        });
    };

    render() {
        if (this.state.isLoaded) {
            return (
                <Row style={{marginTop: '20px'}}>
                    <Col xs={12}>
                        {this.state.results.length > 0 ?
                            <TableContainer component={Paper}>
                                <Table aria-label="simple table" size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center"> </TableCell>
                                            <TableCell align="center">Status</TableCell>
                                            <TableCell align="center">ID</TableCell>
                                            <TableCell align="center">User ID</TableCell>
                                            <TableCell align="center">Name</TableCell>
                                            <TableCell align="center">Data</TableCell>
                                            <TableCell align="center">Duration</TableCell>
                                            <TableCell align="center">Created At</TableCell>
                                            <TableCell align="center">Started At</TableCell>
                                            <TableCell align="center">Ended At</TableCell>
                                            <TableCell align="center">Controls</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.results.map((row) => (
                                            <TaskTableRow key={row.name}
                                                          row={row}
                                                          startTask={this.startTask}
                                                          stopTask={this.stopTask}/>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            : <p>Loading</p>
                        }
                    </Col>
                </Row>
            );
        } else {
            return (
                <div>
                    <center>
                        <p style={{color: 'red'}}>{this.state.msg}</p>
                    </center>
                </div>
            );
        }

    }
}

export default Tasks;
